<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BasicViewer',

  props: {
    pdfData: {
      type: String,
      required: false,
      default: ''
    },
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    }
  },

  methods: {
    onDismissed (target) {
      this.$emit('dismiss', target || true)
    }
  }
})
</script>

<template>
  <div>
    <div v-if="pdfData">
      <object :data="`${pdfData}`" type="application/pdf" :style="{ width, height }"></object>
    </div>
  </div>
</template>
